import { Navigate } from 'react-router-dom';

const SubscriptionPrivateRoutes = ({ children }) => {
	const completed = JSON.parse(localStorage.getItem('subscriptionCompleted') || 'false');

	if (completed) {
		return (
			<Navigate
				to="/payment-success"
				replace
			/>
		);
	}

	return children;
};

export default SubscriptionPrivateRoutes;
